<template>
	<div class="maright" style="position :fixed;bottom:50px;z-index: 999;">

		<div v-if="showservice"
			 style="width: 306px;height: 306px;background-color: white;position :absolute;bottom:0px;right: 52px;">
			<div style="padding: 10px;">
				<div style="font-weight: bold;font-size: 16px;">
					<img style="height: 18px;width: 18px;margin-right: 10px;" src="../static/联系我们ico.png" />联系我们
				</div>
				<div style="padding-left: 29px;margin-top: 5px; font-size: 14px;color: #666666;">
					400-718-0888
				</div>
				<div style="font-weight: bold;font-size: 16px;margin-top: 15px;">
					<img style="height: 18px;width: 18px;margin-right: 10px;" src="../static/联系我们ico.png" />微信客服自咨询
				</div>
				<div style="padding-left: 29px;margin-top: 5px; font-size: 14px;color: #666666;">
					打开微信扫一扫，即可获取人工咨询服务
				</div>
				<div style="width: 140px;height: 140px;margin-right: auto;margin-left: auto; margin-top: 10px; ">
					<img style="width: 140px;height: 140px;" src="../static/wx.png">
				</div>

			</div>
		</div>


		<div style="width: 42px;height: 84px;position :absolute;bottom:0px;right: 0px;">

			<div @click="openservice">
				<img style="width: 42px;height: 42px;" src="../static/客服.png" />
			</div>
			<div @click="gotop">
				<img style="width: 42px;height: 42px;" src="../static/置顶top.png" />
			</div>
		</div>

	</div>
</template>

<script>
	import wlogo from '../static/星链数据横版定稿白色logo.png'
	import clogo from '../static/星链数据横版定稿.svg'
	export default {
		name: 'service',
		data() {
			return {
				showservice: false,
			}
		},
		mounted() {


		},
		methods: {
			openservice: function() {
				this.showservice = !this.showservice
			},

			gotop: function() {
				document.documentElement.scrollTop = 0;
			},
		},

	}
</script>

<style>
	@media (min-width: 1px) {
		.maright {
		 right: 10px;
		
		}
	}
	
	@media (min-width: 1000px) {
		.maright {
			 right: 110px;
		
		}
	}
</style>
